<template>
  <!--header-->

  <!--header end-->
  <!--主体内容开始-->

  <div id="center" style="min-height: 515px">
    <div id="content" class="content">
      <div class="center_content">
        <div class="word">
          <i></i>

          <span>忘记密码</span>
        </div>
        <div class="container">
          <div class="main">
            <p class="tip">忘记密码</p>
            <form class="form-signin" id="itemForm">
              <div class="step0 hide" style="display: none">
                <div class="reg-tab">
                  <span class="tab tab1 on">手机号找回密码</span>
                  <span class="tab tab2">邮箱找回密码</span>
                </div>
                <p class="tab-msg hide">
                  已有账号，去<a href="/login" marked="1">登陆</a>
                </p>
              </div>
              <div class="step1" style="display: block">
                <div class="item phone-reg">
                  <input
                    name="phone"
                    type="num"
                    class="form-control"
                    placeholder="手机号"
                    v-model="confirmTheChange.phonenumber"
                  />
                </div>

                <div class="item short-ipt">
                  <input
                    name="code"
                    type="text"
                    class="form-control short"
                    placeholder="填写短信验证码"
                    v-model="confirmTheChange.code"
                  />
                 <span class="sendCode sendCode1"   type="primary"
                @click="sendATextMessage()"
                :disabled="isDisabled">{{ buttonName }}</span>
                </div>

                <div class="item phone-reg">
                  <input
                    name="phone"
                    type="num"
                    class="form-control"
                    placeholder="用户名"
                    v-model="confirmTheChange.userName"
                  />
                </div>

                <div class="item phone-reg">
                  <input
                    name="phone"
                    type="password"
                    class="form-control"
                    placeholder="密码"
                    v-model="confirmTheChange.password"
                  />
                </div>

                <!-- <div class="item email-reg hide" style="display: none">
                    <input
                      name="email"
                      type="email"
                      class="form-control"
                      placeholder="邮箱地址"
                    />
                  </div> -->
                <div class="item phone-reg short-ipt">
                  <!-- <input
                      class="form-control"
                      type="text"
                      name="captcha"
                      placeholder="输入图形验证码"
                    /> 
                    <div class="captcha-ctn">
                      <div class="captcha-img">
                        <img
                          src="data:image/jpeg;base64,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"
                        />
                      </div>
                      <span class="reload-btn" id="reloadCaptcha">
                        <div class="reload-bg"></div>
                        <span class="reload-txt"
                          >换一张<i class="iconfont"></i>
                        </span>
                      </span>
                    </div>-->
                </div>

                <input
                  type="button"
                  class="btn"
                  id="submitBtn"
                  value="确认修改"
                  @click="changeThePassword()"
                />
              </div>
              <div class="step2">
                <div class="item">
                  <input
                    name="password"
                    type="password"
                    class="form-control"
                    placeholder="填写新密码"
                  />
                </div>
                <div class="item">
                  <input
                    name="password2"
                    type="password"
                    class="form-control"
                    placeholder="再次填写新密码"
                  />
                </div>
                <input
                  type="button"
                  class="btn"
                  id="submitBtn2"
                  value="确认修改"
                />
                <div class="tip2">
                  <p>1、密码长度8-64位</p>
                  <p>
                    2、须同时包含大写字母、小写字母、数字、特殊字符中的任意三种
                  </p>
                  <p>3、密码不能包含邮箱</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--主体内容结束-->
  <!--foot-->
</template>

<script>
import { ref, reactive } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import { forgotPassword ,registeredToSendMessages} from "../assets/api/index";
import router from "../router/index.js";
export default {
  setup() {
 

    //发送短信
    const CountDown = ref(120);
    const buttonName = ref("发送验证码");
    const isDisabled = ref(false);

  //确认修改
    const confirmTheChange = reactive({
      phonenumber: null,
      userName: null,
      password: null,
      code: null,
    });

const changeThePassword = ()=>{
  forgotPassword(confirmTheChange).then((res) => {
if(res.code==200){
 ElMessage.success("修改成功")
}else{
   ElMessage.error(res.msg)
}
      

      });
};

    const sendATextMessage = () => {
      registeredToSendMessages(confirmTheChange.phonenumber).then((res) => {
        var timer = setTimeout(fn, 1000); //定时
        function fn() {
          CountDown.value--;
          if (CountDown.value > 0) {
            buttonName.value = "请等待 " + CountDown.value + " 秒";
            setTimeout(fn, 1000);
            0;
            isDisabled.value = true;
          } else {
            buttonName.value = "重新获取";
            isDisabled.value = false;
          }
        }

        ElMessage.success("短信发送成功!");
      });
    };

  
    return {
      isDisabled,
      buttonName,
      CountDown,
      confirmTheChange,
      changeThePassword,
      sendATextMessage,
    };
  },

  name: "mylogin",
};
</script>

<style src="../assets/css/find-password.css" scoped></style>
<style scoped>
#app {
  width: 100%;
  background: #eee;
}

.el-form.demo-ruleForm {
  margin-top: 23px;
}

.codeys {
  display: flex;
}
.codesleft {
  width: 100%;
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}

/*密码强度*/
.pw-strength {
  clear: both;
  position: relative;
  top: -6px;
  width: 180px;
  left: 98px !important;
}
.pw-bar {
  background: url("../assets/image/pwd-1.png") no-repeat;
  height: 14px;
  overflow: hidden;
  width: 179px;
}

.pw-bar-on {
  background: url("../assets/image/pwd-2.png") no-repeat;
  width: 0px;
  height: 14px;
  position: absolute;
  top: 0 !important;
  left: 2px;
  transition: width 0.5s ease-in;
  -moz-transition: width 0.5s ease-in;
  -webkit-transition: width 0.5s ease-in;
  -o-transition: width 0.5s ease-in;
}
.pw-weak .pw-defule {
  width: 0px;
}
.pw-weak .pw-bar-on {
  width: 60px;
}
.pw-medium .pw-bar-on {
  width: 120px;
}
.pw-strong .pw-bar-on {
  width: 179px;
}
.pw-txt {
  padding-top: 2px;
  width: 180px;
  overflow: hidden;
}
.pw-txt span {
  color: #707070;
  float: left;
  font-size: 12px;
  text-align: center;
  width: 58px;
}
</style>